import * as Yup from "yup";
import { GetErrorObject } from "../Utils";

// const validationSchema = Yup.object().shape({
//   Forename: Yup.string(),
//   Surname: Yup.string()
//     .when('Forename', {
//       is: (val) => val && val?.trim().length > 0, // checks if forename is filled
//       then: Yup.string()
//         .required('Surname is required')
//         .test('no-spaces', 'Surname cannot be empty or just spaces', (value) => {
//           // Check if the value is empty or only spaces
//           return value?.trim().length > 0;
//         }),
//       otherwise: Yup.string(), // no validation if forename is empty
//     }),
// });
const validationSchema = Yup.object().shape({
  Forename: Yup.string(),
  Surname: Yup.string()
    .when('Forename', {
      is: (val) => val && val?.trim().length > 0, // checks if forename is filled
      then: Yup.string()
        .required('Surname is required')
        .test('no-spaces', 'Surname cannot be empty or just spaces', (value) => {
          // Check if the value is empty or only spaces
          return value?.trim().length > 0;
        }),
      otherwise: Yup.string(), // no validation if forename is empty
    }),
  Mobile: Yup.string().nullable(),
  Telephone: Yup.string().nullable(),
}).test(
  'contact-required-if-names-present',
  'Mobile or Telephone is required',
  function (value) {
    const { Forename, Surname, Mobile, Telephone } = value;

    const hasNames =
      Forename?.trim().length > 0 && Surname?.trim().length > 0;
    const hasContact =
      Mobile?.trim().length > 0 || Telephone?.trim().length > 0;

    if (hasNames && !hasContact) {
      return this.createError({
        path: 'Mobile', // You can highlight 'Telephone' instead if preferred
        message:
          'Mobile or Telephone number is required',
      });
    }

    return true;
  }
);


export function ValidateSchema(input) {
  return new Promise(async function (resolve, reject) {
    try {
      validationSchema.validate(input, { abortEarly: false })
        .then(function () {
          const data = {
            Template: {
              ...input,
            },
          };
          resolve({ data });
        })
        .catch(function (err) {
          const errors = GetErrorObject(err);
          resolve({ errors });
        });
    } catch (e) {
      reject(e);
    }
  });
}
